import pixNProgress from '../shared/pixNProgress.js';
import store from '../store/index.js';
import i18nUtils from '../services/i18n/i18n.utils.js';
import webAnalyticsUtils from '@/utils/webAnalytics.utils';
import webAnalyticsEventsConst from '@/consts/webAnalyticsEvents.const';

export const beforeEachGuard = async (to, from, next) => {
  if (!store.getters['authModule/isAuthenticated']) {
    // Console.log('dispatch login');
    await store.dispatch('authModule/login');
  }

  const routeHasAuthRestriction = to.matched.some((route) => route.meta.auth);

  if (routeHasAuthRestriction) {
    const routeDoesNotHaveRoleRestriction = !to.matched.some((route) => route.meta.role);
    const userHasRequiredRoles = to.matched.some((route) => route.meta.role && store.getters['authModule/isInRole'](route.meta.role));

    if (routeDoesNotHaveRoleRestriction || userHasRequiredRoles) {
      i18nUtils.loadLanguageAsync().then(() => next());
    } else {
      /* The user does not have the required roles */
      next({ path: '/errAuth' });
    }
  } else if (to.redirectedFrom === '/' && store.getters['authModule/isInRoleArr']('RTALOS_LANDING_PAGE_SEARCH_DASHBOARD')) {
    i18nUtils.loadLanguageAsync().then(() => next({ path: '/researchDashboard' }));
  } else if (to.path === '/paramlist' && !store.getters['authModule/isInRoleArr']('ADMIN,RF_TALOS_PARAMLIST_MANAGEMENT')) {
    i18nUtils.loadLanguageAsync().then(() => next({ path: '/' }));
  } else {
    /* This page does not require authentication */
    i18nUtils.loadLanguageAsync().then(() => next());
  }
};

export const afterEachGuard = (to) => {
  webAnalyticsUtils.registerWebAnalyticsEvent(webAnalyticsEventsConst.PAGE_LOAD, to.path);
};
